export const operators = {
  equals: '=',
  not: 'is not',
  in: 'in',
  notIn: 'not in',
  lt: '<',
  lte: '<=',
  gt: '>',
  gte: '>=',
  contains: 'contain',
  startsWith: 'startsWith',
  endsWith: 'endsWith',
  isNotEmpty: 'exist',
  isEmpty: 'do not exist',
  hasSome: 'includes',
  none: 'does not include',
}

export const booleanOperators = ['isNotEmpty', 'isEmpty']
